import { useIntl } from 'react-intl';
import { useSafeIsFocused } from '@sg/garnish';

import { useIsLoggedIn } from '../../../../context/AuthMachine';
import { useGiftCardBalanceQuery } from '../../graphql/GiftCardBalance.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useGiftCardBalance = () => {
  const { formatNumber } = useIntl();

  const isLoggedIn = useIsLoggedIn();
  const isScreenFocused = useSafeIsFocused();

  // ─────────────────────────────────────────────────────────────────────

  const [{ data, fetching: isFetching }] = useGiftCardBalanceQuery({
    requestPolicy: 'cache-and-network',
    pause: !isLoggedIn || !isScreenFocused,
  });

  const giftCardBalanceData = data?.giftCardBalance;
  const giftCardBalance =
    giftCardBalanceData?.__typename === 'GiftCardBalance'
      ? giftCardBalanceData.giftCardBalance
      : 0;
  const giftCardBalanceFormatted = formatNumber(giftCardBalance / 100, {
    style: 'currency',
    currency: 'USD',
  });

  // ─────────────────────────────────────────────────────────────────────

  return { balance: giftCardBalanceFormatted, isFetching };
};
